
import { CLICK_COLLECT_ORGS }  from '../constants';
const defaultState = { 
    organizations: []
  };

export const clickCollectOrgs = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {       
        case CLICK_COLLECT_ORGS:
            return {
                ...state,
                ...payload,
            };        
        default:
            return state;
    }
};
